import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppToast from "@toothfairy/shared-ui/AppToast";
import AppUser from "@toothfairy/shared-ui/AppUser";
import React, { useCallback, Suspense } from "react";
import workspacesHelper from "../../API/Workspaces/workspacesHelper";
import { SectionsProvider } from "../../Hooks/useSections";
import useWorkspaces from "../../Hooks/useWorkspaces";
import { useSettingsMenuItems } from "../../Hooks/useSectionMenuItems";
import SettingsScreen from "./SettingsScreen";
import { useTranslation } from "react-i18next";
import { useHistory } from "../../Router";
import usePath from "../../Hooks/usePath";

const SettingsScreenContainer = () => {
  const {
    updateWorkspaceInContext,
    getActiveWorkspace,
    getLastTabSelectedByScreen,
    getLastOptionSelectedByScreen,
    handleSectionSelection,
    isUserAdmin,
    isUserAIEngineer,
    getPlanConfig,
  } = useWorkspaces();
  const history = useHistory();
  const { params } = usePath();
  const AppToasty = AppToast.useToast();
  const { state } = AppStateManager.useAppStateManager();
  const { user } = AppUser.useUser();
  const { t } = useTranslation();
  const _lastTabSelected = getLastTabSelectedByScreen("settings", "INTENT");
  const lastOptionSelected = getLastOptionSelectedByScreen("settings");
  const _isLoaded = params.sectionId && getActiveWorkspace()?.userID;
  const settingsMenuItems = useSettingsMenuItems();
  let _defaultView, _defaultOptId;
  if (_isLoaded) {
    const _sectionUID = params.sectionId?.toUpperCase();
    _defaultView =
      settingsMenuItems?.find((u) => u?.uid === _sectionUID)?.uid ||
      _sectionUID ||
      _lastTabSelected;
    _defaultOptId = params.optId || lastOptionSelected;
    if (!_defaultView) {
      _defaultView = "ROLES_SETTINGS";
    }
  }

  const optionsDataGenerator = useCallback(
    () => settingsMenuItems,
    [settingsMenuItems]
  );
  const handleWorkspaceUpdate = async (property, value) => {
    try {
      const result = await workspacesHelper.updateWorkspace(
        state?.activeWorkspaceID,
        [{ property, value }]
      );
      updateWorkspaceInContext(result);
      AppToasty.show(t("WorkspaceUpdateCaption"), {
        type: "success",
      });
    } catch (error) {
      AppToasty.show(t("WorkspaceUpdateFailedCaption"), {
        type: "danger",
      });
      console.error("An error occured while updating the workspace", error);
    }
  };
  return _defaultView ? (
    <SectionsProvider
      onDisplayedViewChanged={(section, opt_id) => {
        // check if opt_id is a string
        const _optIdSections = [
          "ROLES_SETTINGS",
          "GENERATOR_SETTINGS",
          "EXEC_ENVS",
          "FUNCTIONS",
          "DB_CONNECTIONS",
          "AUTHORISATIONS",
          "CHANNELS",
          "SITES",
          "TRIGGERS",
        ];
        let _appendix = "";
        if (section?.includes("_EDIT") || _optIdSections.includes(section)) {
          if (typeof opt_id === "string") _appendix = `${opt_id}`;
          else if (section == "ROLES_SETTINGS" && opt_id) _appendix = opt_id;
          else
            _appendix =
              opt_id &&
              (opt_id?.type === "topic" ||
                opt_id?.type === "ner" ||
                opt_id?.type === "intent")
                ? opt_id?.id
                : "";
        }
        handleSectionSelection(section, "settings");
        if (state.activeWorkspaceID && section && section !== "MAIN") {
          const target = `/workspaces/${
            state.activeWorkspaceID
          }/settings/${section.toLowerCase()}/${_appendix}`;
          if (history.location?.pathname !== target) history.push(target);
        }
      }}
      optionsDataGenerator={optionsDataGenerator}
      defaultViewUID={_defaultView}
      defaultOptionUID={_defaultOptId}
      sectionsMainTitle={t("settings.workspaceSettings")}
    >
      <Suspense fallback={<div>{t("common.loading")}</div>}>
        <SettingsScreen
          workspace={state?.workspaces?.find(
            (u) => u?.id === state?.activeWorkspaceID
          )}
          handleWorkspaceUpdate={handleWorkspaceUpdate}
        />
      </Suspense>
    </SectionsProvider>
  ) : (
    <></>
  );
};

export default SettingsScreenContainer;
